
import React from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Index from '@/pages/Index';
import NotFound from '@/pages/NotFound';
import EditItemPage from '@/pages/EditItemPage';
import EditAchievementPage from '@/pages/EditAchievementPage';
import HistoryPage from '@/pages/HistoryPage';
import SettingsPage from '@/pages/SettingsPage';
import LandingPage from '@/pages/LandingPage';
import { MetaTags, usePageMeta } from '@/components/MetaTags';

// Protected route wrapper that checks if onboarding is complete
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = React.useState(true);

  React.useEffect(() => {
    const hasCompletedOnboarding = localStorage.getItem('star-chore-onboarding-complete');

    if (!hasCompletedOnboarding) {
      navigate('/welcome');
    } else {
      setIsChecking(false);
    }
  }, [navigate]);

  if (isChecking) {
    return null; // Or a loading spinner
  }

  return <>{children}</>;
};

const AppRoutes: React.FC = () => {
  const location = useLocation();
  const metaData = usePageMeta(location.pathname);

  return (
    <>
      <MetaTags {...metaData} />
      <Routes>
        <Route path="/welcome" element={<LandingPage />} />
        <Route path="/" element={<ProtectedRoute><Index /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
        <Route path="/edit/achievement/:id" element={<ProtectedRoute><EditAchievementPage /></ProtectedRoute>} />
        <Route path="/edit/:type/:id" element={<ProtectedRoute><EditItemPage /></ProtectedRoute>} />
        <Route path="/history" element={<ProtectedRoute><HistoryPage /></ProtectedRoute>} />
        <Route path="/trophies" element={<Navigate to="/" state={{ initialTab: 'trophies' }} />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
